<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <RedirectBack></RedirectBack>
        <span>Dúvidas frequentes</span>
      </h1>
    </div>
  </div>

  <div v-if="faq.id" class="align p-4 space_title">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="p-4">
              <div class="row">
                <div class="col-12 mb-2">
                  <h5>{{ faq.title }}</h5>
                  <p class="date">{{ $dateFormat(faq.created_at) }}</p>
                </div>

                <div class="col-12">
                  <p class="mb-0" v-html="faq.content"></p>
                </div>
              </div>
          </div>
        </div>
    </div>
  </div>

  </div>
</template>
  
<script setup>
import RedirectBack from '@/components/RedirectBack.vue'
import { useFaqStore } from '@/stores/FaqStore'
import { inject, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';

const loader = inject('$loader');

const faqStore = useFaqStore();
const { faq } = storeToRefs(faqStore);

const route = useRoute();

onMounted(async () => {
  faqStore.faq = {};

  const id = route.params.id;
  if(id){
    loader.show();
    await faqStore.getFaq(id);
    loader.hide();
  }
});
</script>

<style scoped>
.date {
  color: #747474;
}

.dark p,
.dark ul {
  color: #cbcfe9 !important;
}
</style>